import React, { useEffect, useState } from 'react'
import { useOutletsQuery } from '../../Store/Apis/outletApi';
import { isDropdownPermission } from '../../Hooks/permissionsMiddleware';
import { useSelector } from 'react-redux';
import { useSupplierListQuery } from '../../Store/Apis/supplierApis';
import { useBrandsQuery, useCreateBrandMutation, useDeleteServiceProductChildMutation, useProductTypeQuery } from '../../Store/Apis/servicesApi';
import toast from 'react-hot-toast';
import { Modal } from 'react-bootstrap';
import AddEditBrand from '../AddEditBrand/AddEditBrand';
import IconSelector from '../IconSelector/IconSelector';

const ConfirmRequisitions = ({submit, data, cancel}) => {
    const user = useSelector((state) => state.auth.user);
    const [sortFilter, setSortFilter] = useState({
        outletID: ''
    });
    const [form, setForm] = useState({
        outletName: '',
        supplierName: '',
        requisitionDate: '',
        requisitionNumber: '',
        requisitionNote: '',
        type: 'product',
        description: '',
        restock: '',
        productDetails: [],
    });
    const [errors, setErrors] = useState({});

    const getSuppliersApi = useSupplierListQuery({
        outletID: sortFilter.outletID
    })
    const brandsApi = useBrandsQuery({
        outletID: sortFilter.outletID
    })
    const serviceTypesApi = useProductTypeQuery({
        outletID: sortFilter.outletID,
    })
    const getOutletApi = useOutletsQuery();

    useEffect(() => {
        if (user.role !== 'superAdmin') {
            setSortFilter({
                outletID: user.outletID
            });
        }
    }, []);

    useEffect(() => {
        if (data) {
            setForm({
                id: data.invoiceId,
                outletName: data.outletID,
                supplierName: data.supplierID,
                requisitionDate: data.invoiceDate.split("T")[0],
                requisitionNumber: data.invoiceNumber,
                requisitionNote: data.invoiceNote,
                type: 'product',       
                description: '',
                restock: '',
                productDetails: data.childRecords.map((elem, i)=> {
                    const items = {
                        productId: elem.productId,
                        childId: elem.childID,
                        code: elem.productCode,
                        description: elem.description,
                        rate: elem.price,
                        type: elem.serviceTypeID,
                        reOrderLevel: elem.reOrder,
                        quantity: elem.quantity,
                        costPrice: elem.costPrice,
                        price: elem.price,
                        icon: elem.iconID,
                        iconString: elem.icon,
                        brand: Number(elem.brandID),
                        name: elem.name                        
                    }
                    return items        
                }),
            });
        }
    }, [data]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };
    

    // ADD BRAND COMPONENT
    const [createBrand, createBrandResponse] = useCreateBrandMutation()
    const [addBrandModalShow, setAddBrandModalShow] = useState(false);
    const AddBrand = () => {        
        // const [createOutlet, createOutletResponse] = useCreateOutletMutation()
        const handleCreateBrandSubmit = (formData) => {
          console.log('Brand Submitted:', formData);
          const brandBody = {
            brandName: formData.brandName,
            categoryId: formData.category,
            image: formData.logo,
            isActive: 0
          }
          createBrand(brandBody).then((res)=>{
            console.log(res)
            if(res?.data?.status == 200) {
                setAddBrandModalShow(false)
                toast.success(res?.data?.message, { duration: 7000 });
            } else {
                toast.error(res?.data?.message, { duration: 7000 })
            }
          }).catch((err)=>{
            toast.error(err, { duration: 7000 })
          })      
        };
    
        return(
          <Modal show={addBrandModalShow} onHide={()=>setAddBrandModalShow(false)} size='md' centered>
            <Modal.Header closeButton>
              <Modal.Title>Add New Brand</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <AddEditBrand onSubmit={handleCreateBrandSubmit}/>
            </Modal.Body>
          </Modal>
        )
    }

    const [showIconModal, setShowIconModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [rowToDelete, setRowToDelete] = useState(null);
    const handleDeleteRow = (index) => {
        setRowToDelete(index);
        setShowDeleteModal(true);
    };
    const handleProductDetailsChange = (index, e) => {
        const { name, value } = e.target;
        const updatedDetails = [...form.productDetails];
    
        // Parse as float if the input field is for costPrice or rate
        updatedDetails[index] = {
            ...updatedDetails[index],
            [name]: name === 'quantity' || name === 'costPrice' || name === 'price' || name === 'rate'
                ? parseFloat(value) || 0
                : value
        };
    
        // Optional: calculate total if needed (depends on your structure)
        if (name === 'quantity' || name === 'costPrice' || name === 'price') {
            const quantity = parseFloat(updatedDetails[index].quantity) || 0;
            const costPrice = parseFloat(updatedDetails[index].costPrice) || 0;
            const price = parseFloat(updatedDetails[index].price) || 0;
            updatedDetails[index].total = (quantity * price).toFixed(2);
        }
    
        setForm({ ...form, productDetails: updatedDetails });
    };
    const addMoreRows = () => {
        setForm({
            ...form,
            productDetails: [
                ...form.productDetails,
                { 
                    type: '', 
                    description: '', 
                    quantity: 0, 
                    costPrice: 0, 
                    price: 0, 
                    reOrderLevel: 0, // Ensure reOrderLevel is initialized
                    rate: 0, // Ensure rate is initialized for services
                    icon: null 
                }
            ]
        });
    };
    const confirmDeleteRow = () => {
        const updatedDetails = form.productDetails.filter((_, i) => i !== rowToDelete);
        setForm({ ...form, productDetails: updatedDetails });
        setShowDeleteModal(false);
    };
    const handleIconSelect = (icon) => {
        console.log(icon)
        setForm({
            ...form,
            productDetails: form.productDetails.map((detail, i) => 
                i === showIconModal.index ? { ...detail, icon: icon.id, iconString: icon.image } : detail
            )
        })
        setShowIconModal(false);
    };


    // HANDLE DELETE
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [deleteServiceProductChild] = useDeleteServiceProductChildMutation()
    const handleDeleteServiceProductChild = (props) => {
        deleteServiceProductChild({
            type: data.type,
            id: selectedRecord.childId
        }).then((res)=>{
            if(res.data.status == 200) {
                setSelectedRecord(null)
            }
        })
    }



    // Validation rules
    const validate = () => {
        const newErrors = {};
        if(!form.requisitionDate){
            newErrors.requisitionDate = 'Requisition Date required';
        }
        if(!form.supplierName){
            newErrors.supplierName = 'Supplier Name is required';
        }
        if (!form.type) {
            newErrors.type = 'Type is required';
        }
        if (form.description && form.description.length < 10) {
            newErrors.description = 'Description must be at least 10 characters long';
        }
        
        
        form.productDetails.forEach((detail, index) => {
            if (!detail.name?.trim()) {
                newErrors[`detail-name-${index}`] = 'Product Name is required';
            }
            if(!detail.brand){
                newErrors[`detail-brand-${index}`] = 'Brand is required';
            }
            if ((form.type === 'product' || form.type === 1) && (isNaN(detail.reOrderLevel) || detail.reOrderLevel < 0)) {
                newErrors[`detail-reOrderLevel-${index}`] = 'Re-Order Level must be a non-negative number';
            }
            if (isNaN(detail.rate) || detail.rate <= 0) {
                newErrors[`detail-rate-${index}`] = 'Rate must be a non-negative number';
            }
            if (!detail.type) {
                newErrors[`detail-type-${index}`] = 'Product Type is required';
            }
            if ((form.type === 'product' || form.type === 1) && (isNaN(detail.quantity) || detail.quantity <= 0)) {
                newErrors[`detail-quantity-${index}`] = 'Quantity must be a positive number';
            }
            if ((form.type === 'product' || form.type === 1) && (isNaN(detail.costPrice) || detail.costPrice <= 0)) {
                newErrors[`detail-costPrice-${index}`] = 'Cost Price must be a positive number';
            }
            if (!detail.code || !detail.code.trim()) {
                newErrors[`detail-code-${index}`] = 'Code is required';
            }
        });
        
        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formErrors = validate();
        if (Object.keys(formErrors).length === 0) {
            const filteredForm = {
                outletID: user.outletID,
                type: 1,
                name: form.name,
                isActive: form.isActive,
                childRecords: form.productDetails.map((detail) => {
                    return {
                        id: detail.productId,
                        childId: detail.childId,
                        code: detail.code,
                        typeId: Number(detail.type),
                        reorderLevel: Number(detail.reOrderLevel),
                        rate: Number(detail.rate),
                        costPrice: Number(detail.costPrice),
                        quantity: Number(detail.quantity),
                        price: detail.price,
                        icon: detail.icon || '',
                        iconString: detail.iconString,
                        description: detail.description,
                        productServiceName: detail.name,
                        brandId: Number(detail.brand),
                    };
                }),
                invoiceID: form.id
            };    

            submit(filteredForm);
        } else {
            setErrors(formErrors);
        }
    };
    
  return (
    <div>
        <form onSubmit={handleSubmit} noValidate>
            <div className="row mb-3">
                <div className="col-md-6">
                    <label>Choose Outlet</label>
                    <select
                        className="form-select"
                        name="outletName"
                        value={form.outletName}
                        onChange={handleInputChange}
                        required
                        disabled={!getOutletApi.isSuccess || !isDropdownPermission(user.role_Id)}
                    >
                        <option value="">Select Outlet</option>
                        {getOutletApi?.data?.data.map(outlet => (
                            <option key={outlet.outletId} value={outlet.outletId}>
                                {outlet.outletName}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-md-6">
                    <label>Choose Supplier</label>
                    <select
                        className={`form-control ${errors.supplierName ? 'is-invalid' : ''}`}
                        name="supplierName"
                        value={form.supplierName}
                        onChange={handleInputChange}
                        required
                        disabled={!getSuppliersApi.isSuccess}
                    >
                        <option value="">Select Supplier</option>
                        {getSuppliersApi?.data?.data.map(supplier => (
                            <option key={supplier.id} value={supplier.id}>
                                {supplier.companyName}
                            </option>
                        ))}
                    </select>
                    {errors.supplierName && <div className="invalid-feedback">{errors.supplierName}</div>}
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-md-6">
                    <label>Requisition Date</label>
                    <input
                        type="date"
                        className={`form-control ${errors.requisitionDate ? 'is-invalid' : ''}`}
                        name="requisitionDate"
                        value={form.requisitionDate}
                        onChange={handleInputChange}
                        required
                    />
                    {errors.requisitionDate && <div className="invalid-feedback">{errors.requisitionDate}</div>}
                </div>
                {
                    data?.invoiceNumber && (
                        <div className="col-md-6">
                            <label>Requisition Number</label>
                            <input
                                type="text"
                                className="form-control"
                                name="requisitionNumber"
                                value={form.requisitionNumber}
                                readOnly
                            />
                        </div>
                    )
                }
            </div>

            <div className="mb-3">
                <label>Requisition Note</label>
                <textarea
                    className="form-control"
                    name="requisitionNote"
                    value={form.requisitionNote}
                    onChange={handleInputChange}
                />
            </div>
            {
                form.productDetails.length > 0 ? form.productDetails.map((detail, index) => (
                    <div className='border p-3 rounded-2 mt-3 mb-3' key={index}>
                        <div className='d-flex justify-content-between mb-2'>
                            <h5 className='mb-0 fs-6 fw-600 mb-0'>Item {index + 1}</h5>
                        </div>
                        <div className="row gy-3 gx-2 mb-2">
                            <div className="col-md-10">
                                <div className="row gy-3 gx-2">
                                    <div className="col-md-6">
                                        <label htmlFor="brand">Brand</label>
                                        <div className='d-flex gap-1 align-items-center'>
                                            <select
                                                name="brand"
                                                value={detail.brand}
                                                onChange={(e) => handleProductDetailsChange(index, e)}
                                                className={`form-select ${errors[`detail-brand-${index}`] ? 'is-invalid' : ''}`}
                                            >
                                                <option value="">Select Brand</option>
                                                {
                                                    brandsApi?.data?.data.map((elem, i) => {
                                                        return(
                                                            <option key={elem.brandID} value={elem.brandID}>{elem.brandName}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                            <button type='button' className="btn btn-outline-primary mb-0 btn-sm d-flex align-items-center" style={{textWrap: 'nowrap', height: '40px'}} onClick={() => setAddBrandModalShow(true)}>
                                                Add Brand
                                            </button>
                                        </div>
                                        {
                                            errors[`detail-brand-${index}`]  && <div className="invalid-feedback d-block">{errors[`detail-brand-${index}`]}</div>
                                        }
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="name">Product Name <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={detail.name}
                                            onChange={(e) => handleProductDetailsChange(index, e)}
                                            className={`form-control ${errors[`detail-name-${index}`] ? 'is-invalid' : ''}`}
                                            required
                                        />
                                        {
                                            errors[`detail-name-${index}`]  && <div className="invalid-feedback d-block">{errors[`detail-name-${index}`]}</div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-2'>
                                <label htmlFor="selectIcon" className='d-block'>Select Icon</label>
                                {
                                    !detail.iconString && 
                                    <button
                                        type="button"
                                        style={{ height: '40px' }}
                                        onClick={() => setShowIconModal({
                                            index,
                                            modal: true
                                        })}
                                        className='btn btn-primary mb-0 btn-sm w-100'
                                    >
                                        Select Icon
                                    </button>
                                }
                                {
                                    detail.iconString && 
                                    <div style={{
                                        height: '40px',
                                        width: '40px',
                                        position: 'relative'
                                    }}>
                                        <button
                                            type='button'
                                            className="badge bg-danger btn btn-danger mb-0 px-2 py-1" 
                                            title="Delete Image" 
                                            style={{
                                                position: 'absolute',
                                                top: '7px', 
                                                left: '110%', 
                                                zIndex: '111'
                                            }}
                                            onClick={() => setForm({
                                                ...form,
                                                productDetails: form.productDetails.map((detail, i) => 
                                                    i === index ? { ...detail, iconString: '', icon: '' } : detail
                                                )
                                            })}
                                        >
                                                <i class="fa fa-trash"></i>
                                        </button>
                                        <img 
                                            src={detail.iconString} 
                                            alt="" 
                                            className='img-thumbnail'
                                            style={{
                                                height: '40px'
                                            }}
                                        />
                                    </div>
                                }  
                            </div>
                        </div>
                        <div className='row g-2'>                            
                            <div className='col-md-4'>
                                <label htmlFor="productServiceType">Product Specification</label>
                                <select
                                    name="type"
                                    value={detail.type}
                                    onChange={(e) => handleProductDetailsChange(index, e)}
                                    className={`form-select ${errors[`detail-type-${index}`] ? 'is-invalid' : ''}`}
                                    required
                                    disabled
                                >
                                    <option value="">Select Type</option>
                                    {
                                        serviceTypesApi?.data?.data.map((elem) => (
                                            <option key={elem.id} value={elem.id}>{elem.serviceTypeName}</option>
                                        ))
                                    }
                                </select>
                                {errors[`detail-type-${index}`] && <div className="invalid-feedback">{errors[`detail-type-${index}`]}</div>}
                            </div>
                            <div className='col-md-4'>
                                <label htmlFor="code">Product Code</label>
                                <input
                                    type="text"
                                    name="code"
                                    value={detail.code || ''}
                                    onChange={(e) => handleProductDetailsChange(index, e)}
                                    className={`form-control ${errors[`detail-code-${index}`] ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors[`detail-code-${index}`] && <div className="invalid-feedback">{errors[`detail-code-${index}`]}</div>}
                            </div>
                            <div className='col-md-4'>
                                <label htmlFor="description">Description</label>
                                <input
                                    type="text"
                                    name="description"
                                    value={detail.description || ''}
                                    onChange={(e) => handleProductDetailsChange(index, e)}
                                    className={`form-control ${errors[`detail-description-${index}`] ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors[`detail-description-${index}`] && <div className="invalid-feedback">{errors[`detail-description-${index}`]}</div>}
                            </div>
                            <div className='col-md-4'>
                                <label htmlFor="reOrderLevel">Re-Order Level</label>
                                <input
                                    type="number"
                                    name="reOrderLevel"
                                    value={detail.reOrderLevel || ''}
                                    onChange={(e) => handleProductDetailsChange(index, e)}
                                    className={`form-control ${errors[`detail-reOrderLevel-${index}`] ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors[`detail-reOrderLevel-${index}`] && <div className="invalid-feedback">{errors[`detail-reOrderLevel-${index}`]}</div>}
                            </div>
                            <div className='col-md-4'>
                                <label htmlFor="quantity">Quantity</label>
                                <input
                                    type="number"
                                    name="quantity"
                                    value={detail.quantity || 0}
                                    onChange={(e) => handleProductDetailsChange(index, e)}
                                    className={`form-control ${errors[`detail-quantity-${index}`] ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors[`detail-quantity-${index}`] && <div className="invalid-feedback">{errors[`detail-quantity-${index}`]}</div>}
                            </div>
                            <div className='col-md-4'>
                                <label htmlFor="price">Cost Price</label>
                                <input
                                    type="number"
                                    name="costPrice"
                                    value={detail.costPrice || 0}
                                    onChange={(e) => handleProductDetailsChange(index, e)}
                                    className={`form-control ${errors[`detail-costPrice-${index}`] ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors[`detail-costPrice-${index}`] && <div className="invalid-feedback">{errors[`detail-costPrice-${index}`]}</div>}
                            </div>
                            <div className='col-md-4'>
                                <label htmlFor="rate">Rate</label>
                                <input
                                    type="number"
                                    name="rate"
                                    value={detail.rate || 0}
                                    onChange={(e) => handleProductDetailsChange(index, e)}
                                    className={`form-control ${errors[`detail-rate-${index}`] ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors[`detail-price-${index}`] && <div className="invalid-feedback">{errors[`detail-rate-${index}`]}</div>}
                            </div>
                        </div>
                    </div>
                )) : (
                    <div className='border p-3 rounded mt-3 mb-3'>
                        <h6 className='text-center mb-0'>No Product available</h6>
                    </div>
                )
            }

            <div className='text-center'>
                <button type="submit" class="btn btn-primary mb-0">Confirm</button>
            </div>
        </form>


        {/* Icon Selection Modal */}
        <Modal 
            show={showIconModal.modal} 
            onHide={() => setShowIconModal({modal: true})}
        >
            <Modal.Body className='p-4'>
                <h5 className='mb-3'>Select Icon</h5>
                <IconSelector handleIconSelect={handleIconSelect} iconId={showIconModal.index && form.productDetails[showIconModal.index].icon}/>                    
                <div className='mt-3 text-center'>
                    <button type='button' className='bg-danger btn btn-danger mb-0 btn-sm' onClick={() => setShowIconModal({modal: false})}>
                        Close
                    </button>
                </div>
            </Modal.Body>
        </Modal>

        {/* Delete Confirmation Modal For Add Product */}
        <Modal 
            show={showDeleteModal} 
            onHide={() => setShowDeleteModal(false)}
            size="sm" 
            centered    
        >
            <Modal.Body className='text-center p-4'>
                <h5>Are you sure you want to delete this row?</h5>
                <p className='text-sm mb-4'>
                    This action will permanently delete the row.
                </p>
                <div className="buttons d-flex gap-3 justify-content-center">
                    <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={() => setShowDeleteModal(false)}>Cancel</button>
                    <button className='btn btn-primary btn-sm mb-0' onClick={confirmDeleteRow}>Confirm</button>
                </div>
            </Modal.Body>
        </Modal>

        {/* DELETE MODAL For Edit Product */}
        <Modal  
            show={selectedRecord} 
            onHide={() => setSelectedRecord(null)} 
            size="sm" 
            centered
        >
            <Modal.Body className='text-center p-4'>
                <h5>Are you sure you want to delete this row?</h5>
                <p className='text-sm mb-4'>
                This action will permanently delete the row.
                </p>
                <div className="buttons d-flex gap-3 justify-content-center">
                    <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={()=>(setSelectedRecord(null))}>Cancel</button>
                    <button className='btn btn-primary btn-sm mb-0' onClick={handleDeleteServiceProductChild}>Confirm</button>
                </div>
            </Modal.Body>
        </Modal>
    </div>
  )
}

export default ConfirmRequisitions